import { Env } from '@stencil/core';
const injectAbdsCommonStylesheet = (function (document: Document, tagName: string, last = false): void {
  const id = 'abds-common-stylesheet';

  if (document.querySelectorAll(id).length === 0) {
    const tag = <HTMLLinkElement>(<unknown>Object.assign(document.createElement(tagName), {
      as: 'style',
      crossorigin: 'anonymous',
      href: `https://unpkg.com/@abds/components@${Env.packageVersion}/dist/apollo/apollo.css`,
      id,
      rel: 'preload stylesheet',
      type: 'text/css',
    }));

    (last && document.head.appendChild(tag)) || document.head.insertBefore(tag, document.head.firstElementChild);
  }
})(window.document, 'link');

/** Injects the AbdsCommon stylesheet into the DOM. from stencil's globalscript option. **/
export default () => {
  injectAbdsCommonStylesheet;
};
